/* ===== Produit complementaire assorti a la couleur (Nelia) =====
   Dans le bloc "Completez l'ensemble", la carte du produit complementaire
   affiche la meme couleur que celle selectionnee sur la page (photo + lien
   vers la bonne variante). Si le produit complementaire n'a pas cette
   couleur, la carte reste telle quelle. */
(function () {
  if (window.__neliaComplColor) return;
  window.__neliaComplColor = true;

  var RE = /couleur|color|colour|coloris|farbe|kleur|\bcor\b/i;
  var cache = {};

  function norm(v) {
    return (v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function getProduct(path) {
    if (!cache[path]) {
      cache[path] = fetch(path + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[path];
  }

  function selectedColor(picker) {
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var checked = fieldsets[i].querySelector('input:checked');
      if (!checked) continue;
      if ((legend && RE.test(legend.textContent)) || RE.test(checked.name || '')) return checked.value;
    }
    var selects = picker.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var label = sel.id ? picker.querySelector('label[for="' + sel.id + '"]') : null;
      if ((label && RE.test(label.textContent)) || RE.test(sel.name || '')) return sel.value;
    }
    return null;
  }

  function withWidth(src, w) {
    var u = new URL(src, window.location.href);
    u.searchParams.set('width', w);
    return u.toString();
  }

  function updateCard(card, color) {
    var link = card.querySelector('a[id^="CardLink-"]') || card.querySelector('a.full-unstyled-link');
    if (!link) return;
    if (!link.dataset.neliaBaseHref) link.dataset.neliaBaseHref = link.getAttribute('href');
    var url = new URL(link.dataset.neliaBaseHref, window.location.origin);
    if (!/\/products\//.test(url.pathname)) return;

    getProduct(url.pathname).then(function (p) {
      if (!p || !p.variants) return;
      var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      var idx = -1;
      for (var i = 0; i < names.length; i++) { if (RE.test(names[i] || '')) { idx = i; break; } }
      if (idx < 0) return;

      var c = norm(color);
      var same = p.variants.filter(function (v) { return norm(v.options[idx]) === c; });
      if (!same.length) return;
      var v = same.filter(function (x) { return x.available; })[0] || same[0];

      var src = v.featured_image && v.featured_image.src;
      if (!src && p.media) {
        var m = p.media.filter(function (md) { return norm(md.alt) === c; })[0];
        if (m) src = (m.preview_image && m.preview_image.src) || m.src;
      }

      url.searchParams.set('variant', v.id);
      link.setAttribute('href', url.pathname + url.search);

      var img = card.querySelector('.card__media img');
      if (img && src) {
        img.setAttribute('src', withWidth(src, 533));
        img.setAttribute('srcset',
          withWidth(src, 165) + ' 165w, ' + withWidth(src, 360) + ' 360w, ' +
          withWidth(src, 533) + ' 533w, ' + withWidth(src, 720) + ' 720w');
        img.setAttribute('alt', color);
      }
    });
  }

  function bind(rec) {
    if (rec.__neliaBound) return;
    rec.__neliaBound = true;
    var scope = rec.closest('section') || document;
    var picker = scope.querySelector('variant-radios[data-section], variant-selects[data-section]') ||
      document.querySelector('variant-radios[data-section], variant-selects[data-section]');
    if (!picker) return;

    var run = function () {
      var color = selectedColor(picker);
      if (!color) return;
      rec.querySelectorAll('.card').forEach(function (card) { updateCard(card, color); });
    };
    picker.addEventListener('change', function () { setTimeout(run, 0); });
    new MutationObserver(run).observe(rec, { childList: true });
    run();
  }

  function init() {
    document.querySelectorAll('product-recommendations.complementary-products').forEach(bind);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
